import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/4_orange/4_orange"
 * Contains 1 texture(s)
 */
export class Desktop4OrangeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/4_orange/4_orange';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '4_orange.png'
    ] as const;
}
